// React
import { useContext } from "react";
// Components
import { SectionContext } from "./SectionContext";

export const useSection = () => {
  return useContext(SectionContext);
};
